export default __webpack_public_path__ + "static/media/img4.dce8c4ff.jpg";